/*
  This util should only be used with dev tools or in a very controlled internal use case.
  It is not intended for use in production code.

  This util simulates a user selecting a value in a react select input.
*/

export function setReactSelectInputValue(inputName: string, value: string) {
  const selectElement = document.querySelector(
    `select[name="${inputName}"]`
  ) as HTMLSelectElement;

  if (selectElement) {
    selectElement.value = value;

    selectElement.dispatchEvent(
      new Event('change', {
        bubbles: true,
      })
    );
  } else {
    console.error(`${inputName} input not found in DOM`);
  }
}
